import React, { useEffect } from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import Reactplayer from "./ReactPlayer";
import DatePicker from "./DatePicker";
import { CheckIcon, XIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import TextCarasoul3 from "./TextCarasoul3";
import AOS from "aos";
import "aos/dist/aos.css";

const HowItWorks = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      <Nav active="howItWorks" />
      <div>
        <div className="bg-[#fff] border-8 border-red-600">
          <div className="max-w-[1320px]  md:mx-auto mx-4 flex justify-center  md:justify-between flex-wrap pt-8">
            <div
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="1000"
              className="flex-grow mx-auto max-w-[600px]"
            >
              <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
                How It Works: Video Editing for YouTube, TikTok, and Instagram
              </h1>
              <p className="mt-6 text-2xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
                With Video Husky, you get a suite of resources to help you
                create your videos. We provide you with an editing team composed
                of an account manager and editor as well as dedicated project
                management workspace and a private Slack channel for streamlined
                communication.
              </p>
              <p className="mt-6 text-2xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
                Submit as many requests as you want. We’ll work on one active
                project at a time. You can get up to 6 total exports per project
                - perfect for repurposing content across a variety of social
                media platforms.
              </p>
              <div className="mt-4 mb-2 text-center md:mt-8 lg:text-left">
                <button className="md:py-4 md:px-6 p-3 mt-2 mr-[1px] md:text-xl text-lg font-semibold bg-[#508dff]  transition duration-200 ease-out text-[#fff] rounded-md hover:shadow-2xl">
                  Book a free consultation!
                </button>
              </div>
              <p className="mt-4 mb-6 text-lg  text-[#4f4f4f]  text-center lg:text-left">
                Action based money back guarantee
              </p>
            </div>
            <div
              data-aos="fade-left"
              data-aos-delay="200"
              data-aos-duration="1000"
              className="flex-grow sm:min-w-[450px] min-w-[290px]  max-w-[591px] mx-auto  px-2 sm:px-4"
            >
              <Reactplayer url="https://www.youtube.com/watch?v=vNx2Z7ePCoM&t=4s" />
            </div>
          </div>
          <img
            src={require("../images/mountain.png")}
            alt=""
            className="w-[100vw] h-80 hidden lg:block"
          />
        </div>
        {/* <div className="-mt-48 bg-white">
          <div className="my-20 pt-36 max-w-[900px] mx-auto px-5">
            <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              Who is this for? (and who not)
            </h1>
          </div>
          <div className=" max-w-[1320px] mx-auto flex justify-around xl:justify-between flex-wrap">
            <div className="flex-grow  max-w-[620px]">
              <h1 className="text-[21px] px-3 text-center  font-bold  mb-8  text-[#1b0c3e] mt-3 hover:opacity-80">
                Video Husky is a good fit if
              </h1>

              <div className="flex items-center justify-between p-6 ">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  Your videos are between 10-20 minutes long
                </p>
                <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                  <CheckIcon className="w-6 h-6 text-green-600" />
                </div>
              </div>
              <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  Your typical raw footage size and running time is 20-40gb and
                  30-60 minutes
                </p>
                <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                  <CheckIcon className="w-6 h-6 text-green-600" />
                </div>
              </div>
              <div className="flex items-center justify-between p-6 ">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  You’re a content creator/make videos for yourself or your
                  business
                </p>
                <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                  <CheckIcon className="w-6 h-6 text-green-600" />
                </div>
              </div>
              <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  You think of your working relationship with an editor as a
                  creative collaboration.
                </p>
                <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                  <CheckIcon className="w-6 h-6 text-green-600" />
                </div>
              </div>
              <div className="flex items-center justify-between p-6 ">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  Have a clear vision of how you want your video to look like
                </p>
                <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                  <CheckIcon className="w-6 h-6 text-green-600" />
                </div>
              </div>
              <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  You use stock animation and graphic templates.
                </p>
                <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                  <CheckIcon className="w-6 h-6 text-green-600" />
                </div>
              </div>

              <div className="flex items-center justify-between p-6 ">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  You shoot your own footage and need a bit of stock footage and
                  templates
                </p>
                <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                  <CheckIcon className="w-6 h-6 text-green-600" />
                </div>
              </div>
            </div>
            <div className="flex-grow max-w-[620px]">
              <h1 className="text-[21px] px-3 text-center  font-bold  mb-8  text-[#1b0c3e] mt-3 hover:opacity-80">
                Video Husky is NOT a good fit if
              </h1>
              <div className="flex items-center justify-between p-6 ">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  Your videos are longer than 20 minutes
                </p>
                <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                  <XIcon className="w-5 h-5 text-red-500" />
                </div>
              </div>
              <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  Your typical raw footage size and running time is over 40gb
                  and 60 minutes.
                </p>
                <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                  <XIcon className="w-5 h-5 text-red-500" />
                </div>
              </div>
              <div className="flex items-center justify-between p-6 ">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  You are an agency/make videos for businesses or other people
                </p>
                <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                  <XIcon className="w-5 h-5 text-red-500" />
                </div>
              </div>
              <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  You prefer immediate interaction or micromanaging your video
                  editor
                </p>
                <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                  <XIcon className="w-5 h-5 text-red-500" />
                </div>
              </div>
              <div className="flex items-center justify-between p-6 ">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  You don’t know what your video should look like
                </p>
                <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                  <XIcon className="w-5 h-5 text-red-500" />
                </div>
              </div>
              <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  Your videos need custom animations and graphics.
                </p>
                <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                  <XIcon className="w-5 h-5 text-red-500" />
                </div>
              </div>
              <div className="flex items-center justify-between p-6 ">
                <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                  You rely only on stock footage
                </p>
                <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                  <XIcon className="w-5 h-5 text-red-500" />
                </div>
              </div>
            </div>
          </div>
          <div className="py-10 my-8 text-center md:py-16">
            <Link to="/category/case-studies">
              <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto">
                Book a free consultation!
              </button>
            </Link>
          </div>
        </div> */}
      </div>
      {/* <div className="bg-[#fff]">
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="mb-12 max-w-[1000px] mx-auto px-5 pt-20 pb-[1px]"
        >
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
            Follow these steps and never edit another video on your own again
          </h1>
        </div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="max-w-[1320px] my-20 md:mt-36 mt-28 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[600px] mb-12">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`CHOOSE EITHER A MONTHLY OR QUARTERLY RETAINER`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`You don't have to worry whether you're getting the most value - we give you everything you need for one flat-fee. You can also choose from a range of production enhancing add-ons, including subtitles, thumbnails and more.`}
            </p>
          </div>
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/3stepesImg1.png")} alt="" />
          </div>
        </div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="max-w-[1320px] my-20 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/followTheseStepsImg2.png")} alt="" />
          </div>
          <div className="flex-grow max-w-[600px]">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`BOOK YOUR CUSTOMER ONBOARDING CALL`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`After you've signed up, you'll schedule an onboarding call with someone from our success team. They'll walk you through how to use our project management dashboard and help you complete a personal bio, which our editing staff will reference when working on your videos.`}
            </p>
          </div>
        </div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="max-w-[1320px] my-20 md:mt-36 mt-28 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[600px] mb-12">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`SEE YOUR NEW PROJECT DASHBOARD`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`You'll be able to create your account on Wrike. Here you can submit your video projects and see their live status, communicate with your editing team, and use the video proofing tool.`}
            </p>
          </div>
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/followTheseStepsImg3.png")} alt="" />
          </div>
        </div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="max-w-[1320px] my-20 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/followTheseStepsImg4.png")} alt="" />
          </div>
          <div className="flex-grow max-w-[600px]">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`SEND US YOUR VIDEO REQUEST FORM TO START YOUR FIRST PROJECT`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`Share a link to your footage and type the editing instructions into the form. You can also include example videos to help us get the look and feel you want.`}
            </p>
          </div>
        </div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="max-w-[1320px] my-20 md:mt-36 mt-28 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[600px] mb-12">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`WE'LL TAKE UP TO 40GB OF FOOTAGE OFF YOUR HANDS AND TURN IT INTO YOUR VISION`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`While your personal editing team is happily working away in the background, you can focus clearly on doing the things that are important to you. Then your PM will quality-check your video before uploading it to your account.`}
            </p>
          </div>
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/followTheseStepsImg5.png")} alt="" />
          </div>
        </div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="max-w-[1320px] my-20 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/followTheseStepsImg6.png")} alt="" />
          </div>
          <div className="flex-grow max-w-[600px]">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`YOU'LL GET YOUR FIRST DRAFT IN JUST 1-2 BUSINESS DAYS DEPENDING ON COMPLEXITY`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`Factors that influence the complexity of your project include how many exports you need, their resolution, amount and type of footage you send, and use of graphics.`}
            </p>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`Turnaround time may be longer to allow for more time to download, review, and export cuts.`}
            </p>
          </div>
        </div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="max-w-[1320px] my-20 md:mt-36 mt-28 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[600px] mb-12">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`EASILY SYNC-UP YOUR VIDEO WITH YOUR EXACT VISION USING THE VIDEO PROOFING TOOL`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`When you're watching your first video draft, you can tap on any area of the video to open-up a comment box and give specific instructions for your editor. E.g. if you want a specific area of a scene color corrected, tap-and-comment on that area and your editor will know exactly what to do!`}
            </p>
          </div>
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/followTheseStepsImg7.png")} alt="" />
          </div>
        </div>
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className="max-w-[1320px] my-20 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/followTheseStepsImg8.png")} alt="" />
          </div>
          <div className="flex-grow max-w-[600px]">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`YOU GET UNLIMITED VIDEO REQUESTS`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#4f4f4f]  text-center lg:text-left opacity-80">
              {`Submit as many video projects to us as you'd like. We'll work on one active project at a time in the order you requested.`}
            </p>
          </div>
        </div>
      </div> */}
      {/* <div className="-mt-20 ">
        <DatePicker />
      </div> */}
      <div className="bg-[#fff] border-8 border-red-600">
        <div
          data-aos="fade-up"
          // data-aos-delay="200"
          data-aos-duration="1000"
          className=" max-w-[1000px] mx-auto px-5 pt-24 pb-20"
        >
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
            Follow these steps and never edit another video on your own again
          </h1>
          <p className="mt-5 md:text-[23px] max-w-[880px] mx-auto text-[18px] leading-9 text-[#4f4f4f]  text-center">
            {`If you don't think we're a good fit within your first 30 days, we'll give you 100% of your money back after you've completed the following:`}
          </p>
          <p className="mt-6 italic md:text-[23px] max-w-[880px] mx-auto text-[18px] leading-9 text-[#4f4f4f]  text-center">
            {`- A customer onboarding session`}
          </p>
          <p className=" md:text-[23px] italic max-w-[880px] mx-auto text-[18px] leading-9 text-[#4f4f4f]  text-center">
            {`- A customer onboarding form`}
          </p>
          <p className=" md:text-[23px] italic max-w-[880px] mx-auto text-[18px] leading-9 text-[#4f4f4f]  text-center">
            {`- Submitted and approved 3 video requests`}
          </p>
        </div>
        <div className="pb-10 text-center ">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#508dff] transition duration-200 ease-out text-[#fff] text-center mx-auto rounded-md hover:shadow-2xl">
              Book a free consultation!
            </button>
          </Link>
          <p className="mt-4 mb-6 text-lg  text-[#6e7c87] opacity-80 text-center ">
            Action based money back guarantee
          </p>
        </div>
      </div>

      {/* <div className="bg-black">
        <TextCarasoul3 />
      </div> */}
      <div className="bg-[#fff] border-8 border-red-600">
        <div data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
          <div className="pt-28 pb-10 max-w-[900px] mx-auto px-5">
            <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              How we make it easy for you
            </h1>
          </div>
          <div className=" max-w-[1320px] mx-auto flex flex-wrap xl:justify-between justify-around pb-28">
            <div className="border m-2 my-4 md:min-w-[420px] md:max-w-[420px] p-8 bg-white  flex-wrap justify-evenly  items-center">
              <img
                src={require("../images/everythingDogImg7.png")}
                alt=""
                className="mx-auto h-44 w-44"
              />
              <div className="max-w-[410px]">
                <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3">
                  {`200gb free cloud storage`}
                </h1>
                <p className=" text-[18px] text-[#4f4f4f]  text-center sm:text-left mt-4 sm:mt-2 ">
                  {`In case you don't have your own cloud storage solution, we offer 200GB of complimentary storage space on Google Drive.`}
                </p>
              </div>
            </div>
            <div className="border m-2 my-4 md:min-w-[420px] md:max-w-[420px] p-8 bg-white  flex-wrap justify-evenly  items-center">
              <img
                src={require("../images/everythingDogImg5.png")}
                alt=""
                className="mx-auto h-44 w-44"
              />
              <div className="max-w-[410px]">
                <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3">
                  {`Video proofing tool`}
                </h1>
                <p className=" text-[18px] text-[#4f4f4f]  text-center sm:text-left mt-4 sm:mt-2 ">
                  {`Get every video frame right. Tap on an area of your video to quickly give specific revision instructions to your editor.`}
                </p>
              </div>
            </div>
            <div className="border m-2 my-4 md:min-w-[420px] md:max-w-[420px] p-8 bg-white  flex-wrap justify-evenly  items-center">
              <img
                src={require("../images/everythingDogImg6.png")}
                alt=""
                className="mx-auto h-44 w-44"
              />
              <div className="max-w-[410px]">
                <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3">
                  {`Free YouTube uploading`}
                </h1>
                <p className=" text-[18px] text-[#4f4f4f]  text-center sm:text-left mt-4 sm:mt-2 ">
                  {`Don't waste time publishing your videos. If you have a YouTube account, we'll publish your videos for you!`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border-8 border-red-600">
        <div className="w-full pt-24 pb-20 px-[20px] md:px-2  max-w-[1320px] mx-auto flex  flex-wrap justify-center xl:justify-between">
          <div className="flex-grow xl:max-w-[500px]  max-w-[700px]">
            <h1 className="md:text-[43px] text-[30px] text-center xl:text-left font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              Your own editing team there for you at the ready
            </h1>
            <div className="mt-4 mb-10 text-center md:mt-8 lg:text-left">
              <Link to="/pricing">
                <button className="p-3 rounded-md mt-1 text-lg font-semibold transition duration-200 ease-out  md:py-4 md:px-7 md:mt-2 md:text-xl bg-[#508dff] text-[#fff] hover:shadow-2xl">
                  See Pricing
                </button>
              </Link>
            </div>
          </div>
          <div className="flex-grow max-w-[750px] ">
            <p className="mt-4 text-2xl leading-9 text-[#4f4f4f]  text-center xl:text-left">
              You can work with us month-to-month or quarterly, with the freedom
              to cancel at any time.
            </p>
            <p className="mt-7 text-2xl leading-9 text-[#4f4f4f]  text-center xl:text-left">
              Let us seamlessly fit into your video creation process and we'll
              save you hundreds of hours on editing.
            </p>
            <p className="mt-7 text-2xl leading-9 text-[#4f4f4f]  text-center xl:text-left">
              And if you want to get more out of Video Husky, you can always
              choose from a range of director chair add-ons to spruce up your
              videos.
            </p>
          </div>
        </div>
      </div>

      {/* <div className="bg-[#fff]">
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className=" max-w-[1000px] mx-auto px-5 pt-24 pb-20"
        >
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
            Let us take your editing workload off your hands
          </h1>
          <p className="mt-5 md:text-[23px] max-w-[880px] mx-auto text-[18px] leading-9 text-[#4f4f4f]  text-center opacity-80">
            {`Meet your new personal video editing team today.`}
          </p>
        </div>
        <div className="pb-10 -mt-12 text-center ">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto">
              Book a free consultation!
            </button>
          </Link>
          <p className="mt-4 mb-6 text-lg  text-[#6e7c87] opacity-80 text-center ">
            Action based money back guarantee
          </p>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};

export default HowItWorks;
